<template>
  <ModalCardDefault :title="l.titleModal" @close="close">
    <ExpansionPanel
      v-model="panel"
      :title="l.titleForm"
      :icon="$icons.box"
      readonly
    >
      <v-form v-model="validForm" ref="validForm" lazy-validation>
        <Row>
          <Col md="6">
            <Select
              v-model="form.id"
              :label="l.fields.invoiceSettings"
              :placeholder="l.fields.invoiceSettings"
              :items="invoiceSettings"
              item-text="description"
              item-value="id"
              return-object
              @change="setInvoiceSetting"
              :rules="[rules.required]"
            />
          </Col>
          <Col md="2">
            <TextField
              v-model="form.model"
              :label="l.fields.model"
              :placeholder="l.fields.model"
              :rules="[rules.required]"
              readonly
            />
          </Col>
          <Col md="2">
            <TextField
              v-model="form.series"
              :label="l.fields.series"
              :placeholder="l.fields.series"
              :rules="[rules.required]"
              readonly
            />
          </Col>
          <Col md="2">
            <TextField
              v-model="form.nf_number"
              :label="'N° da MDF-e'"
              :placeholder="'N° da MDF-e'"
              :rules="[rules.required]"
              readonly
            />
          </Col>
        </Row>
        <Row>
          <Col md="8">
            <TextField
              v-model="form.nf_key_referenceds"
              :label="'Chave da Nota Fiscal Referenciada'"
              :placeholder="'Digite a Chave da Nota Fiscal Referenciada'"
              readonly
            />
          </Col>
          <Col>
            <TextField
              v-model="form.nf_number_referenced"
              :label="'N° da Nota Fiscal Referenciada'"
              :placeholder="'Digite o N° da Nota Fiscal Referenciada'"
              readonly
            />
          </Col>
        </Row>
      </v-form>
    </ExpansionPanel>

    <div slot="actions" class="d-flex justify-end" style="width: 100%">
      <Button
        :label="'Gerar e Transmitir MDF-e'"
        class="mr-3"
        rounded
        color="success"
        @click="generateInvoice({ transmit: true })"
        :loading="loadingGenerateTransmit"
      />
      <Button
        :label="'Gerar MDF-e'"
        class="mr-3"
        rounded
        color="secondary"
        @click="generateInvoice({ transmit: false })"
        :loading="loading"
      />
    </div>

    <Dialog :dialog="dialogActions" no-title :maxWidth="700">
      <ActionsModal
        slot="content"
        :product-invoice-selected="productInvoiceSelected"
        @close="closeActions"
      />
    </Dialog>

    <DialogConfirmation
      :dialog="dialogConfirmation"
      @yesActionDialogConfirmation="showInvoice"
      @noActionDialogConfirmation="closeDialogConfirmation"
      title="Visualizar Nota Fiscal"
      message="Deseja visualizar a Nota Fiscal Gerada?"
    />
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import DialogConfirmation from '@/components/DialogConfirmation';
import {
  ExpansionPanel,
  Row,
  Col,
  TextField,
  Select,
  Button,
  Dialog,
} from '@/components/vuetify';
import { required } from '@/utils/rules';
import {
  typeDocument,
  printerType,
  emissionFinality,
  emissionType,
} from '@/utils/options';
import {
  operationType,
  emissionType as emissionTypeEnum,
  emissionFinality as emissionFinalityEnum,
} from '@/utils/enums';
import ProductInvoiceActionsMixin from '@/mixins/ProductInvoiceActionsMixin';
import ActionsModal from './ActionsModal';

export default {
  name: 'GenerateMdfe',
  components: {
    ModalCardDefault,
    DialogConfirmation,
    ExpansionPanel,
    Row,
    Col,
    TextField,
    Select,
    Button,
    Dialog,
    ActionsModal,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    panel: [0],
    validForm: false,
    loading: false,
    loadingGenerateTransmit: false,
    dialogConfirmation: false,
    dialogActions: false,
    rules: {
      required: required,
    },
    form: {
      invoiceSettingSelected: {},
      id: '',
      model: '',
      series: '',
      nf_number: '',
      nf_key_referenceds: '',  
      nf_number_referenced: '',
    },
    invoiceSettings: [],
    loadingConfirmationTransmit: false,
    productInvoiceSelected: null,
    itemsPrintType: [],
  }),
  computed: {
    l() {
      return this.$locales.pt.orders.list.generateProductInvoice;
    },
    options() {
      return {
        typeDocument,
        printerType,
        emissionFinality,
        emissionType,
      };
    },
    displayReferenceds() {
      return (
        this.form.emission_finality === this.$enums.emissionFinality.DEVOLUTION
      );
    },
  },
  watch: {},
  mixins: [ProductInvoiceActionsMixin],
  methods: {
    async getInvoiceSettings(item) {
      this.$api.invoiceSettings
        .index()
        .then((res) => {
          const {
            data: { invoice_settings },
          } = res;

          this.invoiceSettings = invoice_settings.filter((invoiceSetting) => {
            return invoiceSetting.model === "58"
          });
          this.form = {
            invoiceSettingSelected: this.invoiceSettings[0],
            id: this.invoiceSettings[0].id,
            model: this.invoiceSettings[0].model,
            series: this.invoiceSettings[0].series,
            nf_number: this.invoiceSettings[0].current_number + 1,
            nf_key_referenceds: this.item.key_nfe,
            nf_number_referenced: this.item.nf_number,
          };
          console.log(this.item);
        })
        .catch((err) => {
          console.log(err);
          this.$noty.error('Erro ao buscar configurações da MDF-e');
        });
    },
    setInvoiceSetting(invoiceSetting) {
      console.log(invoiceSetting);
      this.form.invoiceSettingSelected = invoiceSetting;
      this.form.id = invoiceSetting.id;
      this.form.model = invoiceSetting.model;
      this.form.series = invoiceSetting.series;
      this.form.nf_number = invoiceSetting.current_number + 1;
    },
    async generateInvoice({ transmit }) {
      if (!this.$refs.validForm.validate()) {
        return false;
      }

      if (transmit) {
        this.loadingGenerateTransmit = true;
      } else {
        this.loading = true;
      }
      const payload = {
        ...this.form,
        order_id: this.order.id,
        invoice_setting_id: this.form.id,
      };

      if (
        this.form.emission_finality === this.$enums.emissionFinality.DEVOLUTION
      ) {
        payload.referenceds = [this.form.referenceds];

        if (payload.referenceds[0].length !== 44) {
          this.$noty.error('Chave de acesso inválida');
          this.loading = false;
          this.loadingGenerateTransmit = false;

          return;
        }
      }

      const promiseGenerateInvoice = new Promise((resolve, reject) => {
        this.$api.orders
          .generateInvoice(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            this.$noty.error('Erro ao gerar nota fiscal');
            reject(err);
          });
      });

      promiseGenerateInvoice
        .then(({ product_invoice }) => {
          this.productInvoiceSelected = product_invoice;

          if (transmit) {
            const promiseTransmitNFe = new Promise((resolve, reject) => {
              this.$api.productInvoices
                .transmit({ nf_ids: [this.productInvoiceSelected.id] })
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  this.$noty.error('Erro ao transmitir nota fiscal');
                  reject(err);
                });
            });

            return promiseTransmitNFe;
          } else {
            this.$noty.success('Nota Gerada com sucesso');
            this.dialogConfirmation = true;
          }
        })
        .then(({ data }) => {
          if (
            data.protocol.status_code === '100' ||
            data.protocol.status_code === '104'
          ) {
            this.productInvoiceSelected.key_nfe = data.protocol.key_nfe;
            this.$noty.success('NFe transmitida com sucesso');
            this.dialogActions = true;
          } else {
            this.$noty.error(data.protocol.reason);
            this.dialogConfirmation = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.loadingGenerateTransmit = false;
        });
    },
    showInvoice() {
      this.dialogConfirmation = false;
      this.close();
      this.$router.push({
        name: this.$schemas.productInvoice.routes.show.name,
        params: {
          id: this.productInvoiceSelected.id,
        },
      });
    },
    closeDialogConfirmation() {
      this.dialogConfirmation = false;
      this.close();
    },
    close() {
      this.$refs.validForm.reset();
      this.form = {
        invoiceSettingSelected: {},
        id: '',
        model: '',
        series: '',
        nf_number: '',
        nf_key_referenceds: '',
        nf_number_referenced: '',
      };
      this.$emit('close', false)
    },
    closeActions() {
      this.dialogActions = false;
      this.close();
    },
  },
  mounted() {
    this.getInvoiceSettings();
    // this.setInvoiceSetting(this.invoiceSettingSelected);
  },
};
</script>

<style></style>
